import { createSelector } from '@ngrx/store';

import { getCustomerState } from 'ish-core/store/customer/customer-store';

const getAccountNavigationBlocksState = createSelector(getCustomerState, state => state.accountNavigationBlocks);

export const getAccountNavigationBlocks = createSelector(getAccountNavigationBlocksState, state => state.blocks);
